import {
  Navbar,
  Nav,
  Container,
  NavDropdown,
  Button,
  Form,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import { toast } from "react-toastify";

import { FaUser, FaPhoneAlt } from "react-icons/fa"; // Add the icons you need
import { RiLogoutCircleRLine } from "react-icons/ri";
import { CgProfile } from "react-icons/cg";
import { MdQrCode2 } from "react-icons/md";

import { useNavigate } from "react-router-dom";
import { logout, setCredentials } from "../slices/authSlice";

import { useAdminLogoutMutation } from "../slices/AdminSilce";
import { useEffect, useMemo, useState } from "react";
import { useEditOutletDetailsMutation } from "../slices/OutletSlice";
import ReUsableModal from "./ReUsableModal";
import { canAccess, isOwner } from "../utils/adminAccess";

const HeaderLeft = function ({ leftMenuOpen, setExpandMenu }) {
  const { userInfo } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [newStatus, setNewStatus] = useState("");

  const [editDetails, { isLoading }] = useEditOutletDetailsMutation();

  const [logoutApi] = useAdminLogoutMutation();

  const handleLogout = async () => {
    try {
      await logoutApi().unwrap();
      dispatch(logout());
      // dispatch(removeUsers());
      navigate("/login");
      toast.success("Successfully logged out");
    } catch (err) {
      console.log(err);
    }
  };

  const goToSalesPage = (async) => {
    navigate("/sales");
  };
  const goToOnlineOrders = (async) => {
    navigate("/");
  };
  const goToTableOrders = (async) => {
    navigate("/tableOrders");
  };

  const gotoAllFoods = (async) => {
    navigate("/allFoods");
  };

  const handleOutletStatusChange = async () => {
    try {
      const selectedOutletId = userInfo?.selectedOutletId;
      const booleanStatus = newStatus === "Open";
      await editDetails({
        outletId: selectedOutletId,
        currentlyOpen: booleanStatus,
        token: userInfo?.token,
      }).unwrap();
      const updatedOutlets = userInfo?.outletId.map((outlet) =>
        outlet._id === selectedOutletId
          ? { ...outlet, currentlyOpen: booleanStatus }
          : outlet
      );
      const updatedUserInfo = {
        ...structuredClone(userInfo), // ✅ force deep state update
        outletId: updatedOutlets,
      };
      dispatch(setCredentials(updatedUserInfo));
      // toast.success(`Outlet marked as ${newStatus}`);
      setShowModal(false);
      setNewStatus("");
    } catch (err) {
      toast.error("Failed to update outlet status");
      console.error(err);
    }
  };

  const selectedOutlet = userInfo?.outletId?.find(
    (ot) => ot._id === userInfo?.selectedOutletId
  );

  return (
    <header
      style={{
        position: "sticky",
        top: "0px",
        zIndex: 1,
      }}
      className={`headerBg`}
    >
      <ReUsableModal
        title={`Change status to ${newStatus?.toUpperCase()} ?`}
        restrictTitle={
          newStatus === "Open"
            ? "Customers can place orders if status is open"
            : "Customers will not be able to place orders if status is closed"
        }
        show={showModal}
        payload={[]}
        onHide={() => setShowModal(false)}
        onSubmit={handleOutletStatusChange}
        submit="Yes"
        cancel="No"
      />
      {userInfo ? (
        <>
          <Navbar
            style={{
              backgroundColor: "inherit", // Use any hex color code
              height: "3rem",
            }}
          >
            <Container
              style={{
                backgroundColor: "inherit", // Use any hex color code
                height: "40px",
              }}
            >
              <LinkContainer to="/">
                <Navbar.Brand>
                  {/* <img src={logo} alt="zpotter"></img>{" "} */}
                  {/* <label style={{ fontSize: "1.5rem" }}>ZPOTTER</label> */}
                  zutle
                </Navbar.Brand>
              </LinkContainer>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  gap: "10px",
                }}
              >
                <a
                  href="/viewMyOutlets"
                  style={{
                    fontSize: "1.5rem",
                    textDecoration: "none",
                    color: "white",
                  }}
                >
                  {selectedOutlet?.outletName}
                </a>

                <Form.Select
                  style={{
                    width: "5rem",
                    backgroundColor: "transparent",
                    border: "none",
                    color: selectedOutlet?.currentlyOpen ? "yellow" : "orange",
                    fontSize: "0.9rem",
                    fontWeight: "bold",
                    cursor: "pointer",
                    backgroundImage: "none",
                  }}
                  value={selectedOutlet?.currentlyOpen ? "Open" : "Closed"}
                  onChange={(e) => {
                    setNewStatus(e.target.value);
                    setShowModal(true);
                  }}
                >
                  <option value="Open">Open</option>
                  <option value="Closed">Closed</option>
                </Form.Select>
              </div>
              {/* <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav"> */}
              <Nav
                className="ms-auto"
                style={{
                  backgroundColor: "inherit",
                }}
              >
                {userInfo ? (
                  <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontWeight: "10",
                        width: "100%",
                      }}
                    >
                      {/* <FaUserCircle style={{ marginRight: "3px" }} /> */}
                    </div>
                    {canAccess(
                      userInfo,
                      "view_orders_history",
                      "update_order_status",
                      "place_outlet_order"
                    ) && (
                      <Button
                        onClick={goToOnlineOrders}
                        style={{
                          marginRight: "1.5rem",
                          textDecoration: "underline",
                          // border: "none",
                        }}
                      >
                        Orders
                      </Button>
                    )}{" "}
                    {canAccess(userInfo, "place_outlet_order") && (
                      <Button
                        onClick={goToSalesPage}
                        style={{
                          marginRight: "1.5rem",
                          textDecoration: "underline",
                          // border: "none",
                        }}
                      >
                        Sell
                      </Button>
                    )}
                    <Button
                      onClick={gotoAllFoods}
                      style={{
                        marginRight: "1.5rem",
                        textDecoration: "underline",
                        // border: "none",
                      }}
                    >
                      Foods
                    </Button>{" "}
                    {canAccess(userInfo, "manage_table_orders") && (
                      <Button
                        onClick={goToTableOrders}
                        style={{
                          marginRight: "1.5rem",
                          textDecoration: "underline",
                          // border: "none",
                        }}
                      >
                        Table
                      </Button>
                    )}{" "}
                    <NavDropdown
                      title={userInfo?.adminName || "Teju"}
                      style={{ marginRight: "90px" }}
                    >
                      <LinkContainer to="/companyDetails">
                        <NavDropdown.Item>
                          {" "}
                          <CgProfile style={{ marginRight: "3px" }} />
                          {"Company Profile"}
                        </NavDropdown.Item>
                      </LinkContainer>
                      {/* <LinkContainer to="/">
                        <NavDropdown.Item>
                          {" "}
                          <CgProfile style={{ marginRight: "3px" }} />
                          {"View Orders"}
                        </NavDropdown.Item>
                      </LinkContainer> */}
                      {canAccess(
                        userInfo,
                        "view_orders_history",
                        "update_order_status",
                        "place_outlet_order"
                      ) && (
                        <LinkContainer to="/orderHistory">
                          <NavDropdown.Item>
                            <CgProfile style={{ marginRight: "3px" }} />
                            {"Order History"}
                          </NavDropdown.Item>
                        </LinkContainer>
                      )}
                      {/* <LinkContainer to="/allFoods">
                        <NavDropdown.Item>
                          {" "}
                          <CgProfile style={{ marginRight: "3px" }} />
                          {"View FoodItems"}
                        </NavDropdown.Item>
                      </LinkContainer> */}
                      <LinkContainer to="/viewMyOutlets">
                        <NavDropdown.Item>
                          {" "}
                          <CgProfile style={{ marginRight: "3px" }} />
                          {"View Outlets"}
                        </NavDropdown.Item>
                      </LinkContainer>

                      {isOwner(userInfo) && (
                        <>
                          {/* <LinkContainer to="/createFoodItems">
                            <NavDropdown.Item>
                              {" "}
                              <CgProfile style={{ marginRight: "3px" }} />
                              {"Create FoodItems"}
                            </NavDropdown.Item>
                          </LinkContainer> */}
                          <LinkContainer to="/createOutlet">
                            <NavDropdown.Item>
                              {" "}
                              <CgProfile style={{ marginRight: "3px" }} />
                              {"Create Outlet"}
                            </NavDropdown.Item>
                          </LinkContainer>

                          {/* <LinkContainer to="/createAdmin">
                            <NavDropdown.Item>
                              <FaRegEdit style={{ marginRight: "3px" }} />
                              {"Create Admin"}
                            </NavDropdown.Item>
                          </LinkContainer> */}
                        </>
                      )}
                      {isOwner(userInfo) && (
                        <LinkContainer to="/allAdmins">
                          <NavDropdown.Item>
                            {" "}
                            <CgProfile style={{ marginRight: "3px" }} />
                            {"View Admins"}
                          </NavDropdown.Item>
                        </LinkContainer>
                      )}
                      {canAccess(
                        userInfo,
                        "view_customers",
                        "manage_customers"
                      ) && (
                        <LinkContainer to="/customers">
                          <NavDropdown.Item>
                            {" "}
                            <CgProfile style={{ marginRight: "3px" }} />
                            {"Customers"}
                          </NavDropdown.Item>
                        </LinkContainer>
                      )}
                      {canAccess(
                        userInfo,
                        "view_payments",
                        "manage_payments"
                      ) && (
                        <LinkContainer to="/payments">
                          <NavDropdown.Item>
                            {" "}
                            <CgProfile style={{ marginRight: "3px" }} />
                            {"Payments History"}
                          </NavDropdown.Item>
                        </LinkContainer>
                      )}
                      <LinkContainer
                        to="/accounts
                      "
                      >
                        <NavDropdown.Item>
                          {" "}
                          <CgProfile style={{ marginRight: "3px" }} />
                          {"Accounts & Finance"}
                        </NavDropdown.Item>
                      </LinkContainer>

                      <LinkContainer to="/generateQR">
                        <NavDropdown.Item>
                          <MdQrCode2 style={{ marginRight: "2px" }} />
                          Generate QR Code
                        </NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer to="/contactUs">
                        <NavDropdown.Item>
                          {" "}
                          <FaPhoneAlt style={{ marginRight: "2px" }} />
                          Contact Us
                        </NavDropdown.Item>
                      </LinkContainer>
                      <NavDropdown.Item onClick={handleLogout}>
                        <RiLogoutCircleRLine style={{ marginRight: "3px" }} />
                        Logout
                      </NavDropdown.Item>
                    </NavDropdown>
                  </>
                ) : (
                  <LinkContainer to="/login">
                    <Nav.Link>
                      <FaUser />
                      Login
                    </Nav.Link>
                  </LinkContainer>
                )}
              </Nav>
              {/* </Navbar.Collapse> */}
            </Container>
          </Navbar>
        </>
      ) : (
        <></>
      )}
    </header>
  );
};

export default HeaderLeft;
